import React, { Component } from 'react';

import { connect } from 'react-redux';

import { openDrawer, closeDrawer } from 'actions/drawer';
import { addNotification } from 'actions/notifications';

import { PanelSection, PanelSectionWithLabel } from 'components/PanelSections';

import { Classroom } from 'models';
import { validate } from 'models/validate';


import { VisibleOnlyAdmin, VisibleOnlyCustomer } from 'components/AuthenticatedComponent';
import ContentHeader from 'components/ContentHeader';
import ContentFooter from 'components/ContentFooter';

import Score from 'components/Score';
import StudentMetricsPanelListItem from './PupsquestMetricsPanelListItem';

import './pupsquestMetricsPanel.scss';

class PupsquestMetricsPanel extends Component {

	constructor (props) {
		super(props);

		this.state = {};
	}

    updateAverage(lesson){
        this.setState({
            lesson : lesson
        });
    }

	render () {
	    let title = `Really Reading Audio Score \n Student: ${this.props.student.name} \n Lesson ${this.props.lesson.name}`;
	    let score = this.props.lesson.reallyreading1 + '%';
	    let component = (
            <Score
                value={this.props.lesson.reallyreading1}
                divisor={100}
                text={score}
                boxClass="metrics-box-color"
                textClass="score-text"
            />
		);

		return (
            <div className="panel grades-panel">
                <ContentHeader
                    title={title}
					component={component}
                    closeable="true"
                    onClose={this.props.closeDrawer}
                />
                <div className="panel-content">
                    <div className="container">
                        {this.props.lesson.reallyreading.map( (audioItem, index) => {
                            return (
                                <StudentMetricsPanelListItem
                                    key={index}
                                    count={index + 1}
                                    recording={audioItem}
									student={this.props.student}
									classroom={this.props.classroom}
									lesson={this.props.lesson}
                                    updateAverage={this.updateAverage.bind(this)}
                                />
                            );
                        })}
                    </div>
                </div>
                <ContentFooter
                    onClose={this.props.closeDrawer}
                    onCancel={this.props.onCancel}
                    confirmLabel="Save Grades"
                    onConfirm={function () {
                        this.props.addNotification('add-save-grades-success-' + Date.now(), 'Grades Saved');
                        this.props.closeDrawer();
                    }.bind(this)}
                />
            </div>);
	}
}

const mapStateToProps = (state) => {
	return { user : state.user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PupsquestMetricsPanel);




// WEBPACK FOOTER //
// ./js/components/PupsquestMetricsPanel/PupsquestMetricsPanel.js